import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '../Banner';
import BM from '../../models/gallery.model';
import { fetchBanner } from '../../services/banner.service';
import {Skeleton}  from '@material-ui/lab';
import {useParams} from 'react-router-dom';
interface state{
  banner:{
    banner:BM,
    loading:boolean
  },
}

interface Props{
  home?:boolean
}

interface params{
  dist_slug:string
}

const HomeBanner:React.FC<Props> = (props) =>{

  const {home} = props;

  const {dist_slug} = useParams<params>();

  const dispatch = useDispatch();

  // globle state
  const state = useSelector((state:state)=>{
    const {banner} = state;
    return banner;
  })
  const {banner,loading} = state;
  // end globle state



  //fetch banner
  const loadBanner = ()=>{
    dispatch(fetchBanner(dist_slug||'head-office'));
  }; 



  useEffect(()=>{
   loadBanner();
  },[dispatch])//eslint-disable-line

return(
  <>
  {!loading?
  <Banner banners={banner} home={home}/>  
  :<Skeleton variant="rect" animation="wave" height={400} />}
  </>
);
}

export default HomeBanner;